<template>
  <div class="detail-wrap">
    <!-- <div
      class="delete"
      @click="deteleDetail"
    >删除</div> -->
    <ul class="ul-detail">
      <li class="">
        <div class="text-left">所在地</div>
        <div class="text-right">{{addressData.address}}</div>
      </li>
      <li class="van-hairline--bottom van-hairline--top">
        <div class="text-left">详细地址</div>
        <div class="text-right r2">{{addressData.detailAddress}}</div>
      </li>
      <li>
        <div class="text-left">作业亩数</div>
        <div class="text-right">{{addressData.cropNumber}}亩</div>
      </li>
    </ul>
    <div
      class="btn"
      @click="deteleDetail"
    >删除</div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "addressDetail",
  components: {},
  props: {},
  data() {
    return {
      showIconFlag: false,
      addressData: this.$route.query.data
    };
  },
  computed: {},
  watch: {},
  mounted() {
    // console.log("this.$route.query.data :", this.$route.query.data);
  },
  destroyed() {},
  methods: {
    ...mapMutations(["delAddressOne"]),
    deteleDetail() {
      this.$dialog.confirm({
          message: "确定删除？"
        })
        .then(() => {
          this.delAddressOne(this.$route.query.data);
          this.$router.push("/secondBar/medication");
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>
<style lang="stylus" scoped>
.detail-wrap
  position relative
  .delete
    position absolute
    right 13px
    top 11px
    z-index 2
    font-size 15px
    font-family Microsoft YaHei
    font-weight 400
    color rgba(255, 255, 255, 1)
  .ul-detail
    margin-top 10px
    text-align left
    & > li
      background #fff
      min-height 50px
      display flex
      line-height 50px
      padding 16px 13px
      .text-left
        width 80px
        line-height 1.2
      .text-right
        flex 1
        line-height 1.2
  .btn
    width 60%
    height 40px
    line-height 40px
    margin 0 auto
    border-radius 20px
    font-size 17px
    color #FFFFFF
    background #55CC99
    margin-top 50px
</style>